import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from 'primeng/components/common/message';
import { Coupon, CreateCouponModel } from '../../../models/inModels/Coupon';
import { AppComponent } from '../../../app.component';
import { CouponService } from '../../../services/coupon/coupon.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SelectItem } from "primeng/components/common/selectitem";
import { BookService } from "../../../services/book.service";

@Component({
	selector: 'app-coupons-create',
	templateUrl: './coupons-create.component.html',
	styleUrls: ['./coupons-create.component.css']
})
export class CouponsCreateComponent implements OnInit {
	modelCreate: CreateCouponModel;
	loading = false;
	msg: Message[];
	coupon: Coupon;
	couponCode: string;
	createCustomCode: string;
	binaryValue: number;
	form: FormGroup;
	products: SelectItem[];
	selectedProduct: SelectItem;

	constructor(
		private router: Router,
		private app: AppComponent,
		private couponsService: CouponService,
		private bookService: BookService,
		private formBuilder: FormBuilder) {
		this.modelCreate = new CreateCouponModel();
		this.modelCreate.Books = false;
		this.modelCreate.PercentageDiscount = 1;
	}

	ngOnInit() {
		this.form = this.formBuilder.group({
			binaryInput: ['', Validators.pattern('[0-1]')]
		});
	}

	goBack() {
		this.router.navigate(['/coupons']);
	}

	create(): void {
		this.loading = true;
		console.log(this.modelCreate);
		this.modelCreate.RedemptionCount = this.binaryValue;
		this.couponsService.create(this.modelCreate)
			.subscribe(
				coupon => {
					this.coupon = coupon;
					this.loading = false;
					console.log(coupon);
					this.msg = [];
					this.msg.push({ severity: 'success', summary: 'Success', detail: 'Coupon Created' });
				},
				error => {
					this.loading = false;
					this.msg = [];
					this.msg.push({ severity: 'error', summary: 'Error', detail: error });
				});

	}

	validateBinaryInput(event: any) {
		const inputChar = String.fromCharCode(event.charCode);
		if (inputChar !== '0' && inputChar !== '1') {
			event.preventDefault();
			this.showErrorMessage();
		}
	}

	showErrorMessage() {
		this.msg = [];
		this.msg.push({ severity: 'error', summary: 'Error', detail: 'Please enter 0 or 1.' });
		setTimeout(() => {
			this.msg = [];
		}, 4000);
	}

	initDropDown(event) {
		this.bookService.getDropdown(event).then(
			x => {
				this.products = x;
			},
			error => {
				this.msg = [];
				this.msg.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setProduct(): void {
		this.modelCreate.BookId = this.selectedProduct.value;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/coupons/coupons-create/coupons-create.component.ts